// salesData.js
export const salesData = {
    all_users: '2,431,340',
    total_earning: '540,549',
    sales: '1,205,677',
    purchases: '48,430,039',
    active_users: '92,980',
    active_user_per: '27%',
    new_users: '22,652',
    new_user_per: '67%',
    chicago: {
      name: 'Chicago',
      count: '98,320,300'
    },
    berlin: {
      name: 'Berlin',
      count: '76,541,106'
    },
    manaus: {
      name: 'Manaus',
      count: '12,320,300'
    },
    giza: {
      name: 'Giza',
      count: '10,547,980'
    },
    shanghai: {
      name: 'Shanghai',
      count: '239,570,110'
    },
    queensland: {
      name: 'Queensland',
      count: '6,097,321'
    },
    sales_figure: '$10,430'
  };
  